import logoWhite from './logo_white.svg';

const HomePage = () => {

    return (
      <>
        <img src={logoWhite} className="App-logo" alt="logo" style={{marginTop: 30}} />
        <div style={{marginTop: 250, marginBottom: 80}}>Browse reviews and evaluate courses <br/>
of your mobility exchange.
       </div>
      </>
    );
  };

  export default HomePage;

